import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/logo.svg";
import LogoutIcon from "../shared/icons/LogoutIcon";
import UserIcon from "../shared/icons/UserIcon";
import ResultsIcon from "../shared/icons/ResultsIcon";
import ListIcon from "../shared/icons/ListIcon";
import XIcon from "../shared/icons/XIcon";
import MenuIcon from "../shared/icons/MenuIcon";

const NavbarForAdmin = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login";
  };

  const navLinkStyle = ({ isActive }) =>
    `flex items-center gap-2 py-1 ${
      isActive ? "text-blue-600" : "text-gray-700 hover:text-blue-600 transition"
    }`;

  return (
    <header className="bg-white shadow-md p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img src={logo} alt="Логотип" className="h-10" />
          <span className="text-xl font-semibold text-gray-800 ">
            Админ-панель
          </span>
        </div>

        <div className="sm:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700">
            {isOpen ? <XIcon/> : <MenuIcon />}
          </button>
        </div>

        <nav className="hidden sm:flex gap-5 text-base font-semibold">
          <NavLink to="/all-tests" className={navLinkStyle}>
            Тесты <ListIcon className="w-[20px]" />
          </NavLink>
          <NavLink to="/results" className={navLinkStyle}>
            Результаты <ResultsIcon className="w-[20px]" />
          </NavLink>
          <NavLink to="/profile" className={navLinkStyle}>
            Профиль <UserIcon className="w-[20px]" />
          </NavLink>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-red-700 hover:text-red-600 transition"
          >
            Выход <LogoutIcon className="w-[20px]" /> 
          </button>
        </nav>
      </div>

      {isOpen && (
        <nav className="sm:hidden mt-4 flex flex-col items-end gap-4 text-lg font-semibold">
          <NavLink to="/all-tests" className={navLinkStyle} onClick={() => setIsOpen(false)}>
            Тесты <ListIcon className="w-[20px]" />
          </NavLink>
          <NavLink to="/results" className={navLinkStyle} onClick={() => setIsOpen(false)}>
            Результаты <ResultsIcon className="w-[20px]" />
          </NavLink>
          <NavLink to="/profile" className={navLinkStyle} onClick={() => setIsOpen(false)}>
            Профиль <UserIcon className="w-[20px]" />
          </NavLink>
          <button
            onClick={() => {
              setIsOpen(false);
              handleLogout();
            }}
            className="flex items-center gap-2 text-red-700 hover:text-red-600 transition"
          >
            Выход <LogoutIcon className="w-[20px]" />
          </button>
        </nav>
      )}
    </header>
  );
};

export default React.memo(NavbarForAdmin);
